import React, { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
// import moment from "moment";

import Footer from "../../../components/layout/Footer";
import {
  handleLogin,
  handleQueryLogin,
  // getRequestTime,
  // sendOtp, validateOtp
} from "../../../services/auth";
import ForgotPassword from "../ForgotPassword";
// import OtpPhase from "../OtpPhase";
import { Loginform } from "./LoginForm";
import { Mixpanel } from "../../../constants/mixpanel";
import { useLocation } from "react-router-dom";
import { decryptData } from "../../../utils";
import Loader from "../../../components/ui/Loader";
import { toast, ToastContainer } from "react-toastify";
import { useSetRecoilState } from "recoil";
import { currentRole } from "../../../store";

const SignIn = () => {
  const navigate = useNavigate();
  const setRole = useSetRecoilState(currentRole);
  const [isIncorrectPassword, setInorrectPassword] = React.useState<boolean>(false);
  const [isUserRegistered, setIsUserRegistered] = React.useState<string>("");
  const [isForgotPassword, setIsForgotPassword] = React.useState<boolean>(false);
  const [, saveUserData] = React.useState({ email: "", password: "" });
  const [isDisabled, setIsDisabled] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [signInError, setSignInError] = React.useState<string>("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryid = queryParams.get("id");

  const decryptedId = decryptData(queryid ? queryid : "");

  const queryLogin = (data:any) => {
    setLoading(true);
    handleQueryLogin({
     queryid: decryptedId,
    })
      .then((response: any) => {
        if (response?.data) {
          const decodedToken: any = jwtDecode(response.data.idToken);      
          const { everestPartner } = response && response.data;
          if (decodedToken?.sub?.toLowerCase() === response?.data?.userDetails?.email.toLowerCase()) {
            localStorage.setItem("userKey", response.data.vendor_key);
            localStorage.setItem("userToken", response.data.idToken);
            localStorage.setItem("currentUser", JSON.stringify(response.data));
            localStorage.setItem("everestPartner", everestPartner);
            navigate("/home");
          }
          else{
            toast.error("Given URL is not valid, please try again");
            setTimeout(() => {
              navigate("/auth/sign-in");
            }, 2000);
          }
        }
      })
      .catch((error) => {
        console.error("err", error);
        if (
          error?.response?.Message ===
          "The User ID is incorrect, Please try again"
        ) {
        // toast.error("Incorrect Login Credentials");
        toast.error("Given URL is not valid, please try again");
        setTimeout(() => {
          navigate("/auth/sign-in");
        }, 2000);
      }})
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    if(queryid){
      queryLogin({data: decryptedId});
    }
  }, [queryid]);
  

  const onLogin = (data: any) => {
    setLoading(true);
    handleLogin({
      email: data.email,
      password: data.password,
      isOtpVerified: true,
    })
      .then((response: any) => {
        if (response?.data) {
          const decodedToken: any = jwtDecode(response.data.idToken);
          const { username, partner_type, vendor_key, phoneNumber,everestPartner } = response && response.data;
          if (username && phoneNumber) {
            Mixpanel.identify(phoneNumber);
            Mixpanel.identify(phoneNumber);
            const mixpanelProps = {
              username: username,
              $email: username,
              email: username,
              partner_type: partner_type,
              vendor_key: vendor_key,
            };
            Mixpanel.people.set(mixpanelProps);
            Mixpanel.track("Login", mixpanelProps);
          }
          if (decodedToken.sub.toLowerCase() === data.email.toLowerCase()) {
            setInorrectPassword(false);
            localStorage.setItem("userKey", response.data.vendor_key);
            localStorage.setItem("userToken", response.data.idToken);
            localStorage.setItem("currentUser", JSON.stringify(response.data));
            localStorage.setItem("everestPartner", everestPartner);
            const jwtToken = response.data.idToken;
            const payLoad = jwtDecode<any>(jwtToken);
            setRole(payLoad?.Role);
            // setActiveStep(2);
            navigate("/home");
          }
        }
      })
      .catch((error) => {
        console.error("err", error);
        if (
          error?.response?.Message ===
          "The user name and/or password are incorrect, Please try again"
        ) {
          setIsUserRegistered("Incorrect Email");
          setIsUserRegistered("");
          setSignInError("Incorrect Password/Email");
          setInorrectPassword(true);
        }
        if (error?.response?.data?.Message === "Vendor details not found") {
          setIsUserRegistered(error?.response?.data?.Message);
          setSignInError(error?.response?.data?.Message);
          setInorrectPassword(false);
        }
      })
      .finally(() => setLoading(false));
  };

  const handleClickedLogin = (data: any) => {
    onLogin(data);
  };


  return (
    queryid ? <>
      <ToastContainer position="top-center" /><Loader /></> :

      <div className="flex flex-col items-center">
      <Loginform
      isUserRegistered={isUserRegistered}
      isIncorrectPassword={isIncorrectPassword}
      setIsForgotPassword={setIsForgotPassword}
      setInorrectPassword={setInorrectPassword}
      setIsUserRegistered={setIsUserRegistered}
      saveUserData={saveUserData}
      isDisabled={isDisabled}
      setIsDisabled={setIsDisabled}
      handleClickedLogin={handleClickedLogin}
      signInError={signInError}
      loading={loading}
      />
      <Footer />
      <ForgotPassword
      isForgotPassword={isForgotPassword}
      setIsForgotPassword={setIsForgotPassword}
      />
      </div>
    
  );
};

export default SignIn;
